export default class Modal {
	static instance = null;

	constructor(el) {
			this.$el = $(el)
			this.$trigger = $(el)
			this.modalName = this.$el.data('modal-trigger')
			this.$modal = $(`[data-modal="${this.modalName}"]`)
			this.$allModals = $('[data-modal]')
			this.$closeButton = this.$modal.find('[data-close]')
			this.init()
			this.$el[0].controller = this
			Modal.instance = this;
	}
	init() {
		const {$trigger, $closeButton} = this
		$trigger.on('click', this.showModal.bind(this))
		$closeButton.on('click', this.closeModal.bind(this))
	}
	showModal(e){
		e.preventDefault()
		this.$allModals.fadeOut()
		this.$modal.stop().fadeIn()
		
	}
	closeModal(e){
		e.preventDefault()
		this.$modal.fadeOut()
	}
}
